(function(){
  'use strict';

  const CARE_PAGES=new Set([
    '/pages/faq',
    '/pages/shipping-delivery',
    '/pages/returns-refunds',
    '/pages/contact',
    '/pages/data-sharing-opt-out'
  ]);
  const CACHE=new Map();
  let navigating=false;
  let animationFrame=0;
  let restoreScrollStyle=null;

  function normalize(path){
    const clean=(path||'/').replace(/\/+$/,'');
    return clean||'/';
  }

  function urlOf(value){
    try{return new URL(value,location.href)}catch(_){return null}
  }

  function isCareUrl(url){
    if(!url||url.origin!==location.origin)return false;
    const path=normalize(url.pathname);
    return CARE_PAGES.has(path)||path.indexOf('/policies/')===0;
  }

  function reduceMotion(){
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function scroller(){
    if(window.matchMedia('(min-width: 990px)').matches){
      const wrapper=document.querySelector('.page-wrapper');
      if(wrapper instanceof HTMLElement)return wrapper;
    }
    return document.scrollingElement||document.documentElement;
  }

  function isWindowScroller(el){
    return el===document.scrollingElement||el===document.documentElement||el===document.body;
  }

  function scrollStyleElement(){
    const el=scroller();
    return isWindowScroller(el)?document.documentElement:el;
  }

  function forceInstantScrolling(){
    if(restoreScrollStyle)return;
    const el=scrollStyleElement();
    const previous=el.style.scrollBehavior;
    el.style.scrollBehavior='auto';
    restoreScrollStyle=function(){
      el.style.scrollBehavior=previous;
      restoreScrollStyle=null;
    };
  }

  function restoreScrolling(){
    if(restoreScrollStyle)restoreScrollStyle();
  }

  function scrollTop(){
    const el=scroller();
    if(isWindowScroller(el))return window.scrollY||document.documentElement.scrollTop||document.body.scrollTop||0;
    return el.scrollTop;
  }

  function setScrollTop(value){
    const y=Math.max(0,value||0);
    const el=scroller();
    if(isWindowScroller(el))window.scrollTo(0,y);
    else el.scrollTop=y;
  }

  function viewportHeight(){
    const el=scroller();
    return isWindowScroller(el)?window.innerHeight:el.clientHeight;
  }

  function cancelGlide(){
    if(animationFrame){
      cancelAnimationFrame(animationFrame);
      animationFrame=0;
    }
    restoreScrolling();
  }

  function glideToTop(from,onDone){
    cancelGlide();
    forceInstantScrolling();
    if(reduceMotion()||from<2){
      setScrollTop(0);
      restoreScrolling();
      if(onDone)onDone();
      return;
    }
    const duration=Math.min(820,Math.max(500,430+from*0.055));
    const start=performance.now();
    function frame(now){
      const t=Math.min(1,(now-start)/duration);
      const eased=1-Math.pow(1-t,4);
      setScrollTop(from*(1-eased));
      if(t<1)animationFrame=requestAnimationFrame(frame);
      else{
        animationFrame=0;
        setScrollTop(0);
        restoreScrolling();
        if(onDone)onDone();
      }
    }
    animationFrame=requestAnimationFrame(frame);
  }

  function parsePage(html){
    const doc=new DOMParser().parseFromString(html,'text/html');
    const main=doc.querySelector('#MainContent');
    if(!main)throw new Error('Lumiera navigation: destination content not found');
    return {main:main,title:doc.title||document.title};
  }

  function cacheKey(url){
    return url.pathname+url.search;
  }

  function fetchPage(url){
    const key=cacheKey(url);
    if(CACHE.has(key))return CACHE.get(key);
    const request=fetch(url.href,{
      method:'GET',
      credentials:'same-origin',
      headers:{'X-Requested-With':'LumieraNavigation'}
    }).then(function(response){
      if(!response.ok)throw new Error('Lumiera navigation: '+response.status);
      return response.text();
    }).then(parsePage).catch(function(error){
      CACHE.delete(key);
      throw error;
    });
    CACHE.set(key,request);
    return request;
  }

  function markPage(main,url){
    if(!main)return;
    const path=normalize(url.pathname);
    if(path==='/pages/data-sharing-opt-out')main.setAttribute('data-lumiera-care','privacy-choices');
    else if(main.getAttribute('data-lumiera-care')==='privacy-choices')main.removeAttribute('data-lumiera-care');
  }

  function importMain(page,url){
    const next=document.importNode(page.main,true);
    markPage(next,url);
    return next;
  }

  function prefetchLinks(root){
    const scope=root||document;
    const links=scope.querySelectorAll('a[href]');
    links.forEach(function(link){
      const url=urlOf(link.href);
      if(isCareUrl(url)&&url.pathname!==location.pathname)fetchPage(url).catch(function(){});
    });
  }

  function prefetchKnownPages(){
    CARE_PAGES.forEach(function(path){
      if(normalize(location.pathname)===path)return;
      fetchPage(new URL(path,location.origin)).catch(function(){});
    });
    prefetchLinks(document);
  }

  function swapPage(url,page,historyMode){
    const current=document.getElementById('MainContent');
    if(!current)throw new Error('Lumiera navigation: current content not found');

    cancelGlide();
    forceInstantScrolling();
    const startTop=scrollTop();
    const holdHeight=Math.max(current.scrollHeight,startTop+viewportHeight()+160);
    const next=importMain(page,url);
    next.style.minHeight=holdHeight+'px';
    next.style.overflowAnchor='none';

    current.replaceWith(next);
    document.title=page.title;

    if(historyMode==='push')history.pushState({lumieraCare:true},'',url.pathname+url.search+url.hash);
    else if(historyMode==='replace')history.replaceState({lumieraCare:true},'',url.pathname+url.search+url.hash);

    setScrollTop(startTop);

    requestAnimationFrame(function(){
      requestAnimationFrame(function(){
        restoreScrolling();
        glideToTop(startTop,function(){
          next.style.minHeight='';
          next.style.overflowAnchor='';
          navigating=false;
          prefetchLinks(next);
        });
      });
    });
  }

  function nativeFallback(url){
    cancelGlide();
    navigating=false;
    location.href=url.href;
  }

  function navigate(url,historyMode){
    if(navigating)return;
    navigating=true;
    fetchPage(url).then(function(page){
      swapPage(url,page,historyMode||'push');
    }).catch(function(){
      nativeFallback(url);
    });
  }

  function eligibleClick(event,link,url){
    if(event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return false;
    if(!(link instanceof HTMLAnchorElement)||link.hasAttribute('download')||link.hasAttribute('data-no-smooth-navigation'))return false;
    if(link.target&&link.target.toLowerCase()!=='_self')return false;
    if(!url||url.origin!==location.origin||url.hash)return false;
    if(url.pathname===location.pathname&&url.search===location.search)return false;
    return true;
  }

  document.addEventListener('click',function(event){
    if(!(event.target instanceof Element))return;
    const link=event.target.closest('a[href]');
    const url=link?urlOf(link.href):null;
    if(!eligibleClick(event,link,url))return;

    const currentUrl=new URL(location.href);
    if(!isCareUrl(currentUrl)||!isCareUrl(url))return;

    event.preventDefault();
    navigate(url,'push');
  },true);

  document.addEventListener('pointerenter',function(event){
    if(!(event.target instanceof Element))return;
    const link=event.target.closest('a[href]');
    if(!link)return;
    const url=urlOf(link.href);
    if(isCareUrl(url))fetchPage(url).catch(function(){});
  },true);

  document.addEventListener('touchstart',function(event){
    if(!(event.target instanceof Element))return;
    const link=event.target.closest('a[href]');
    if(!link)return;
    const url=urlOf(link.href);
    if(isCareUrl(url))fetchPage(url).catch(function(){});
  },{capture:true,passive:true});

  window.addEventListener('popstate',function(){
    cancelGlide();
    navigating=false;
    const url=new URL(location.href);
    if(isCareUrl(url)){
      navigate(url,'none');
      return;
    }
    location.reload();
  });

  function init(){
    const main=document.getElementById('MainContent');
    markPage(main,new URL(location.href));

    if(isCareUrl(new URL(location.href))){
      try{history.scrollRestoration='manual'}catch(_){}
      history.replaceState(Object.assign({},history.state||{},{lumieraCare:true}),'',location.href);
    }

    prefetchKnownPages();
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
